import { render, staticRenderFns } from "./NotificationDrawerItem.vue?vue&type=template&id=ae9250a6&scoped=true"
import script from "./NotificationDrawerItem.vue?vue&type=script&lang=js"
export * from "./NotificationDrawerItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationDrawerItem.vue?vue&type=style&index=0&id=ae9250a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9250a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9250a6')) {
      api.createRecord('ae9250a6', component.options)
    } else {
      api.reload('ae9250a6', component.options)
    }
    module.hot.accept("./NotificationDrawerItem.vue?vue&type=template&id=ae9250a6&scoped=true", function () {
      api.rerender('ae9250a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/NotificationDrawerItem.vue"
export default component.exports